import formatCaption from './formatCaption';
import themeEditor from './themeEditor';

export default () => {
  formatCaption();
  themeEditor();
};